import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var UserRole;
(function (UserRole) {
    let AccessLevel;
    (function (AccessLevel) {
        AccessLevel[AccessLevel["SMS"] = 1] = "SMS";
        AccessLevel[AccessLevel["WEB"] = 2] = "WEB";
        AccessLevel[AccessLevel["VOICE_MENU"] = 4] = "VOICE_MENU";
    })(AccessLevel = UserRole.AccessLevel || (UserRole.AccessLevel = {}));
    UserRole.get = createAccessors(arrayGetSet('user_roles'), {
        name: 'Роль',
        access_level_register: 0,
        managed_guard_zone_list: [],
        user_list: [],
    });
})(UserRole || (UserRole = {}));
